<template>
    <div>
        <v-img
        :src="getImage(contents[0])"
        class="transparent mb-4"
        aspect-ratio="1.4"
        v-if="getImage(contents[0]) != '' && !agProfile"
        >
            <template v-slot:placeholder>
                <v-layout
                fill-height
                align-center
                justify-center
                ma-0
                >
                <v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
                </v-layout>
            </template>
        </v-img>
        <div class="px-1" v-html="contents[0] ? contents[0].Body.replace(``,'') : ''"></div>
        <div v-if="contents[0].Files.length > 0">
            <p class="subheading mt-4">ޑޮކިއުމެންޓްތައް</p>
            <p v-for="a in getWithoutImages(contents[0].Files)" :key="a.ID + 'FileDownload'">
                <v-icon color="primary" class="ml-2">mdi-file</v-icon><a :href="`${$url}/downloadfile/${a.ID}`" v-html="a.FileTitle"></a>
            </p>
            <!-- <p v-else class="subheading">-</p> -->
        </div>
    </div>
</template>
<script>
    export default {
        props: ['contents'],
        methods: {
            getWithoutImages (files) {
                return files.filter(item => !item.FileType.includes('image'))
            },
            getImage(item) {
                // console.log('item.Files')
                if (item.Files && item.Files.length > 0) {
                    let images = item.Files.filter(obj => obj.FileType.includes('image'))
                    if (images.length > 0) {
                    return `${this.$url}/downloadfile/${images[0].ID}`
                    }
                    else {
                    return ''
                    }
                }
                else {
                    return ''
                }
            }
        }
    }
</script>